import { useEffect } from "react";
import PropertyInput from "../inputs/input-property.tsx";
import { useStore } from "../../state/state.ts";
import { MainPropertyKey } from "../../state/properties.ts";

export function InputVerbrauch() {
   const heizung = useStore((state)=>state.heizung);
   const api_basic_data = useStore((state)=>state.api_basic_data);
   const verbrauchseinheit_oel = useStore((state)=>state.verbrauchseinheit_oel);
   const verbrauchseinheit_gas = useStore((state)=>state.verbrauchseinheit_gas);
   const verbrauchseinheit_holz = useStore((state)=>state.verbrauchseinheit_holz);
   const verbrauchseinheit_andere = useStore((state)=>state.verbrauchseinheit_andere);

   console.log(verbrauchseinheit_gas, verbrauchseinheit_holz);

   // useEffect(()=>{
   //    api_basic_data();
   // },[heizung]);

   let type : MainPropertyKey;
   let label_override = "Gasverbrauch";

   switch (heizung) {
      case "heating_system_current_0":
      case "heating_system_current_8":
      case "heating_system_current_10":
         type="oelverbrauch";
         label_override = "Ölverbrauch";
         break;
      case "heating_system_current_1":
      case "heating_system_current_7":
      case "heating_system_current_9":
         if(verbrauchseinheit_gas == "m3"){
            type="gasverbrauch_m3"
         }else {
            type="gasverbrauch"
         }
         break;
      case "heating_system_current_2":
         if(verbrauchseinheit_holz == "t"){
            type="holzverbrauch_t";
         }else if(verbrauchseinheit_holz == "m3"){
            type="holzverbrauch_m3";
         }else {
            type="holzverbrauch";
         }
         label_override = "Holzverbrauch";
         break;
      case "heating_system_current_3":
      case "heating_system_current_4":
         type="stromverbrauchwaermepumpe";
         label_override = "Stromverbrauch";
         break;
      case "heating_system_current_6":
         type="gasverbrauch";
         label_override="Fernwärmeverbrauch";
         break;
   }

   return <PropertyInput placeholder_prefix="z.B." type={type} label_override={label_override}/>
}

export function InputVerbrauchsEinheit() {
   const heizung = useStore((state)=>state.heizung);
   const api_basic_data = useStore((state)=>state.api_basic_data);

   const verbrauchseinheit_oel = useStore((state)=>state.verbrauchseinheit_oel);
   const verbrauchseinheit_gas = useStore((state)=>state.verbrauchseinheit_gas);
   const verbrauchseinheit_holz = useStore((state)=>state.verbrauchseinheit_holz);
   const verbrauchseinheit_andere = useStore((state)=>state.verbrauchseinheit_andere);

   // useEffect(()=>{
   //    api_basic_data();
   // },[verbrauchseinheit_oel, verbrauchseinheit_gas, verbrauchseinheit_holz, verbrauchseinheit_andere]);


   const verbrauch = ()=>{
      switch (heizung) {
         case "heating_system_current_0":
         case "heating_system_current_8":
         case "heating_system_current_10":
            return <PropertyInput type="verbrauchseinheit_oel"/>;
         case "heating_system_current_1":
         case "heating_system_current_7":
         case "heating_system_current_9":
            return <PropertyInput type="verbrauchseinheit_gas"/>;
         case "heating_system_current_2":
            return <PropertyInput type="verbrauchseinheit_holz"/>;
         case "heating_system_current_3":
         case "heating_system_current_4":
         case "heating_system_current_6":
         default:
            return <PropertyInput type="verbrauchseinheit_andere"/>

      }
   }

   return <>{ verbrauch() }</>;
}